import type { Directive } from 'vue'

/**
 * Renders pre-sanitized HTML without the `v-html` directive, which this
 * project's ESLint config forbids unconditionally (`vue/no-v-html: error`,
 * with no per-file suppression allowed). The caller is responsible for
 * sanitizing the bound value (e.g. via useMenuDescriptionFormat's `format`)
 * before passing it in -- this directive only performs the DOM assignment.
 */
export const vSafeHtml: Directive<HTMLElement, string> = {
  mounted(el, binding) {
    el.innerHTML = binding.value
  },
  updated(el, binding) {
    if (binding.value !== binding.oldValue) el.innerHTML = binding.value
  }
}
